import { motion } from "framer-motion";
import { STATS } from "@/data/services";

const EASE = [0.76, 0, 0.24, 1];

export const StatsStrip = () => {
  return (
    <section className="relative bg-[var(--bg)] py-24 md:py-32 border-b border-[var(--line)]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="md:col-span-4"
        >
          <p className="overline mb-4">The record</p>
          <h2 className="font-display text-3xl md:text-4xl tracking-tight leading-[1.05] text-[var(--ink)]">
            Fourteen years.
            <br />
            <span className="font-serif-accent text-[var(--accent)]">
              Twenty countries.
            </span>
            <br />
            One partner.
          </h2>
        </motion.div>

        <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.75, delay: 0.1 * i, ease: EASE }}
              className="border-t border-[var(--line-strong)] pt-6"
            >
              <div className="font-display text-5xl md:text-6xl tracking-[-0.03em] text-[var(--ink)] leading-none">
                {s.value}
              </div>
              <p className="mt-4 text-[11px] uppercase tracking-[0.24em] text-[var(--ink-50)]">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
